<template>
    <div class="ui middle aligned center aligned grid">
        <div v-if="!login" class="column">
            <h2 class="ui black header">
                가온로지스닷넷
            </h2>
            <form class="ui large form" @submit.prevent="onSubmit">
                <div class="ui stacked segment">
                    <div class="field">
                        <div class="ui left icon input">
                            <i class="user icon"></i>
                            <input type="text" name="id" placeholder="아이디를 입력하세요." v-model="id" autocomplete="off">
                        </div>
                    </div>
                    <div class="field">
                        <div class="ui left icon input">
                            <i class="lock icon"></i>
                            <input type="password" name="password" placeholder="비밀번호를 입력하세요." v-model="password" autocomplete="off">
                        </div>
                    </div>
                    <button class="ui fluid large black submit button">로그인</button>
                </div>
            </form>
        </div>
        <div v-if="login" class="column">
            <h2 class="ui inverted header">로그인중..</h2>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            id: '',
            password: '',
            login: 0,
        }
    },
    created: function() {
        this.login = true;
        this.$api.getLogin((resData) => {
            if (resData.user) {
                this.user = resData.user;
                this.partners = resData.partners;
                this.centers = resData.centers;
                this.products = resData.products;
                this.workers = resData.workers;
                this.$router.push("search/index");
            } else {
                this.login = false;
            }
        });
    },
    methods: {
        onSubmit() {
            if (!this.login) {
                this.login = true;
                this.$api.login(this.id, this.password, (resData) => {
                    if (resData.error) {
                        this.login = false;
                        alert(resData.error.message);
                    } else if (resData.user) {
                        this.user = resData.user;
                        this.partners = resData.partners;
                        this.centers = resData.centers;
                        this.products = resData.products;
                        this.workers = resData.workers;
                        this.$router.push("search/index");
                    }
                });
            }
        },
    },
    computed: {
        user: {
            get: function() { return this.$store.getters.user; },
            set: function(val) { this.$store.commit("setUser", val); },
        },
        partners: {
            get: function() { return this.$store.getters.partners; },
            set: function(val) { this.$store.commit("setPartners", val); },
        },
        centers: {
            get: function() { return this.$store.getters.centers; },
            set: function(val) { this.$store.commit("setCenters", val); },
        },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(val) { this.$store.commit("setProducts", val); },
        },
        workers: {
            get: function() { return this.$store.getters.workers; },
            set: function(val) { return this.$store.commit("setWorkers", val); },
        },
    },
}

</script>

<style>
.grid {
    margin: 0;
    width: 100%;
    height: 100%;
}
.column {
    max-width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/IndexPage.vue